import { mockMenuLinks } from '@/utils/constants/mock-links';
import ArrowIcon from '@/icons/arrows/solid.svg';
import Link from 'next/link';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import s from './links-dropdown.module.scss';

// const swapElements = (arr: Array<any>, i: number, j: number) => {
//   const newArr = [...arr];
//   [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
//   return newArr;
// };

const LinksDropdown = () => {
  const t = useTranslations('Common');
  const { pathname, events } = useRouter();
  const [isHovering, setIsHovering] = useState<string | null>(null);

  const handleHover = (titleKey: string | null) => () => {
    if (titleKey === 'headerLink6') return;

    setIsHovering(titleKey);
  };

  useEffect(() => {
    const handleRouteChange = () => {
      setIsHovering(null);
    };

    events.on('routeChangeComplete', handleRouteChange);

    return () => {
      events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);

  return (
    <div>
      {/* {swapElements(mockMenuLinks, 4, 5).map((link) => ( */}
      {mockMenuLinks.map((link) => (
        <div
          className={s.wrap}
          key={link.href}
          onMouseEnter={handleHover(link.titleKey)}
          onMouseLeave={handleHover(null)}
        >
          {!link.href ? (
            <p key={link.titleKey}>
              {t(link.titleKey)} <ArrowIcon />
            </p>
          ) : (
            <Link
              prefetch={false}
              href={link.href}
              className={clsx({ active: pathname === link.href })}
            >
              {t(link.titleKey)} {!link.href.includes('blog') && <ArrowIcon />}
            </Link>
          )}

          {isHovering === link.titleKey && (
            <div
              className={clsx(s.dropdownMenu, {
                [s.netw]: link.titleKey === 'headerLink5',
              })}
            >
              {link.links?.map((link: { titleKey: string; href: string }) => (
                <Link
                  key={link.titleKey}
                  href={link.href}
                  prefetch={false}
                  className={clsx({ [s.active]: pathname === link.href })}
                >
                  {t(link.titleKey)}
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default LinksDropdown;
